"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.DiscountContainer = exports.Discount = exports.CostPerDay = exports.DateSection = exports.PeriodTitle = exports.PeriodSelectionCardContainer = void 0;
const styled_components_1 = __importStar(require("styled-components"));
exports.PeriodSelectionCardContainer = styled_components_1.default.div `
	width: 250px;
	height: 250px;
	border-radius: ${props => props.theme.borderRadius.large};
	display: flex;
	flex-direction: column;
	align-items: center;
	justify-content: space-between;
	padding: 1rem;
	gap: 1rem;
	cursor: pointer;
	${props => props.shouldBeHighlighted
    ? (0, styled_components_1.css) `
					border: 3px solid ${({ theme }) => theme.color.brand1};
			  `
    : (0, styled_components_1.css) `
					border: 3px solid ${({ theme }) => theme.color.gray5};
			  `}
`;
exports.PeriodTitle = styled_components_1.default.h3 `
	font-weight: bold;
	font-size: 1.5rem;
	${props => props.shouldBeHighlighted &&
    (0, styled_components_1.css) `
			color: ${props.theme.color.brand1};
		`}
`;
exports.DateSection = styled_components_1.default.div `
	display: flex;
	align-items: center;
	gap: 0.5rem;
	color: ${props => props.theme.color.gray7};
`;
exports.CostPerDay = styled_components_1.default.div `
	font-size: 1.5rem;
	${props => props.isWithoutDiscount &&
    (0, styled_components_1.css) `
			display: flex;
			align-items: center;
		`}
`;
exports.Discount = styled_components_1.default.span `
	font-size: 1.75rem;
	color: ${props => props.theme.color.success};
`;
exports.DiscountContainer = styled_components_1.default.div `
	display: flex;
	align-items: center;
	gap: 0.5rem;
	margin-top: -0.5rem;
	margin-bottom: -0.5rem;
`;
